import { render, staticRenderFns } from "./PlaylistList.vue?vue&type=template&id=0973e1ea"
import script from "./PlaylistList.vue?vue&type=script&lang=js"
export * from "./PlaylistList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports